export default "__VITE_ASSET__lUfYEVhu__"